import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../components/Common/backBtn";
import InputTextField from "../../../components/Common/inputTextField";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import SucessModal from "../../../components/Modal/SucessModal";
import JoditEditor from "jodit-react";

const AddFaqForm = ({ edit = false, view = false }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    register,
    setValue,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      faqs: [{ faq_question: "", faq_answer: "" }],
    },
  });

  const { fields, append, update, replace } = useFieldArray({
    control,
    name: "faqs",
  });

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if ((edit || view) && id) {
      const fetchFaq = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}healthsy-pharmacy/faq-masters/${id}`
          );

          if (res.data?.faqs) {
            reset({ faqs: res.data.faqs });
            replace(res.data.faqs);
          }
        } catch (err) {
          console.error("Failed to fetch FAQ:", err);
        }
      };
      fetchFaq();
    }
  }, [edit, view, id, reset, replace]);

  const onSubmit = async (data) => {
    try {
      console.log("payload: ", data.faqs);

      let res;
      if (edit && id) {
        res = await axios.put(
          `${process.env.REACT_APP_API_URL}healthsy-pharmacy/faq-masters/${id}`,
          { faqs: data.faqs }
        );
      } else {
        res = await axios.post(
          `${process.env.REACT_APP_API_URL}healthsy-pharmacy/faq-masters/create-multiple`,
          { faqs: data.faqs }
        );
      }

      if (res.status === 200) setSuccess(true);
    } catch (err) {
      console.error("Submit failed: ", err);
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Franchise programme", link: "/franchise-programme" },
      { text: "FAQ Masters", link: "/franchise-programme/faq-masters" },
      {
        text: edit ? "Edit FAQ" : view ? "View FAQ" : "Add New FAQ",
        link: "",
      },
    ],
    [edit, view]
  );

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
            <Breadcrumbs
              className="w-75 healthsyMasterBreadCrumbs"
              breadcrumbsList={breadcrumbsList}
            />
            <div className="d-flex gap-3 justify-content-between">
              <BackBtn navigatePath="/franchise-programme/faq-masters" />
              {!view && (
                <button
                  type="button"
                  className="addPlusIcon text-end text-white border-0"
                  onClick={() => {
                    const last = fields[fields.length - 1];
                    if (
                      !last.faq_question?.trim() ||
                      !last.faq_answer?.trim()
                    ) {
                      alert("Current fields should not be empty!");
                      return;
                    }
                    append({ faq_question: "", faq_answer: "" });
                  }}
                >
                  Add More
                </button>
              )}
            </div>
          </div>
        }
        footer={<></>}
      >
        <div className="healtharticle">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="carr-dep-form"
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          >
            <div className="row car-dep-form g-4 m-3">
              {fields.map((item, index) => (
                <div key={item.id} className="border rounded p-3 mb-4 bg-light">
                  <h6>FAQ #{index + 1}</h6>

                  {/* Question */}
                  <InputTextField
                    labelName="FAQ Question"
                    name={`faqs.${index}.faq_question`}
                    register={register}
                    errors={errors}
                    errorText="Please enter the question"
                    placeholder="Enter FAQ Question"
                    disable={view}
                    className="w-100"
                  />

                  {/* Answer */}
                  <label className="form-label fw-bold mt-3">FAQ Answer</label>
                  {view ? (
                    // 🔹 Just display answer in view mode
                    <div
                      className="border p-2 rounded bg-white"
                      dangerouslySetInnerHTML={{ __html: item.faq_answer }}
                    />
                  ) : (
                    <JoditEditor
                      value={item.faq_answer}
                      config={{
                        readonly: view,
                        height: 300,
                      }}
                      onBlur={(value) => {
                        update(index, { ...item, faq_answer: value });
                        setValue(`faqs.${index}.faq_answer`, value);
                      }}
                    />
                  )}
                  {errors?.faqs?.[index]?.faq_answer && (
                    <p className="text-danger">Please enter the answer</p>
                  )}
                </div>
              ))}
            </div>
            {/* Submit */}
            {!view && (
              <div className="m-5 text-center">
                <button
                  type="submit"
                  className="btn btn-success"
                  style={{ border: "none" }}
                >
                  {edit ? "Update FAQ(s)" : "Submit All"}
                </button>
              </div>
            )}
          </form>
        </div>
      </MainconternLayout>

      {success && (
        <SucessModal
          page={"/franchise-customers/faq-masters"}
          name="FAQ(s)"
          post={edit ? "updated" : "added"}
          onClose={() => navigate("/franchise-customers/faq-masters")}
        />
      )}
    </>
  );
};

export default AddFaqForm;
